import React, { PureComponent, Fragment } from 'react';
import Collapsible from 'react-collapsible';


class Continents extends PureComponent {

  constructor(props){
    super(props);

    this.state = {
      accordionOpen:true,
      accordiontransitionTime:300,
      activeFilter:""
    }



  }


  static getDerivedStateFromProps(nextProps, prevState){
     if(nextProps.active !== prevState.activeFilter){
        return {
          activeFilter:nextProps.active
        }
     }
     return null;
  }

  onContinentClick(e, continentName){
    e.preventDefault();
    this.props.onSelect(continentName);
  }

  setActiveFilter(currentItem){
    return (currentItem === this.state.activeFilter) ? 'active-filter' : "";
  }


  renderCollapsible(){

    const { accordionOpen, accordiontransitionTime } = this.state;

    return (
       <Collapsible
         trigger="Destination"
         open={accordionOpen}
         transitionTime={accordiontransitionTime}>
          {
            Object.entries(this.props.data).map((item, i) => {
            return <p key={`${item[1].name}`}><a href="" className={this.setActiveFilter(item[1].name)} onClick={e => this.onContinentClick(e, `${item[1].name}` )}>{`${item[1].name} (${item[1].count})`}</a></p>
            })
          }
      </Collapsible>
    )
  }

  renderOptionsMenu(){
    return (
      <div className="options-menu-destination">
          <p className="subtitle">Destination</p>
          <ul>
          {
            Object.entries(this.props.data).map((item, i) => {
            return <li key={`${item[1].name}`}><a href="" className={this.setActiveFilter(item[1].name)} onClick={e => this.onContinentClick(e, `${item[1].name}` )}>{`${item[1].name} (${item[1].count})`}</a></li>
            })
          }
          </ul>
      </div>
    )
  }

  render(){
    return (
      <Fragment>
        { this.props.type === "no-collapse" ? this.renderOptionsMenu() : this.renderCollapsible() }
      </Fragment>
    )
  }

}

export default Continents;



// WEBPACK FOOTER //
// ./src/components/tripSearch/filters/components/continents.js